<div class="team-management-container">
  <nav class="left-nav">
    <!-- Left nav content (if any) -->
  </nav>
  <div class="master-container">
    <div class="header-row">
      <h1>{{ heading }}</h1>
      <div
        class="select-container"
        *ngIf="isDataLoaded && reporteeData.length > 0"
      >
        <iskill-searchable-select
          [options]="teamOptions"
          placeholder="All Teams"
          [value]="selectedTeamLabel"
          (valueChange)="onTeamPick($event)">
        </iskill-searchable-select>
      </div>
    </div>

    <div>
      <app-team-management-cards></app-team-management-cards>
    </div>

   <!--  <div>
      <app-team-management-action-items></app-team-management-action-items>
    </div> -->

    <div class="row-container row-two">
      <app-team-management-row-two></app-team-management-row-two>
    </div>

    <div class="row-three">
      <app-team-composition-list></app-team-composition-list>
    </div>
  </div>
</div>
